import React from "react";
import { observer } from "mobx-react-lite";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { AuditContextList } from "./list";
import { AuditContextCreate } from "./create";
import { AuditContextDetailRoute } from "./detailRoute";
import { ConsoleContext } from "../../mobxStores/consoleContext/consoleContext";

const AuditContextRoute: React.FC = () => {
  const { org } = ConsoleContext;

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<AuditContextList />} />
        <Route path={`-create/*`} element={<AuditContextCreate />} />
        <Route path={`:auditctx/*`} element={<AuditContextDetailRoute />} />
      </Routes>
    </Layout>
  );
};

export default observer(AuditContextRoute);
